import PropTypes from "prop-types";
import { useMediaQuery } from "react-responsive";
import DeceptionDesktop from "./DeceptionDesktop";
import DeceptionMobile from "./DeceptionMobile";

function Deception({ app, config, filter }) {
  const isMobile = useMediaQuery({ query: "(max-width: 980px)" });

  return isMobile ? (
    <DeceptionMobile app={app} config={config} filter={filter} />
  ) : (
    <DeceptionDesktop app={app} config={config} filter={filter} />
  );
}

Deception.defaultProps = {
  app: null,
  config: {},
  filter: "",
};

Deception.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
  filter: PropTypes.string,
};

export default Deception;
